import React from "react";

const JQuery_Stop = () => {
  return (
    <div>
      <h1>JQuery_Stop</h1>
      <p>Placeholder component for: "JQuery_Stop"</p>
    </div>
  );
};

export default JQuery_Stop;
